import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'currencyTranslate',
})
export class CurrencyTranslate implements PipeTransform {
  transform(value: string): string {
    const res = (Number(value) / 100).toFixed(2);
    return `¥${res}`;
  }
}
